import type { BackendProsjektRow } from "./types";

export const mockProsjekter: BackendProsjektRow[] = [
    {
        saksnummer: "24/7589",
        prosjekttittel: "Bølgekraft med lagring på Utsira",
        prosjekteier: "980123456",
        stottebelop_vedtatt: 9273281,
        levetid_estimert: 5,
        klimaresultat_vedtatt: 512465,
        energiresultat_vedtatt: 1250000,
        stotteobjekt_navn: "Ladeanlegg",
        stotteobjekt_antall: 4,
        status: "Under gjennomføring",
        stotteprogram: "Teknologiutvikling",
        sektor: "Maritim transport",
        prosjektfylke: "Rogaland",
        prosjektkommune: "Utsira",
        prosjektstart_gjeldende_tid: 1577836800000,
        prosjektslutt_gjeldende_tid: 1735603200000,
        beskrivelse: "Firma:HYDRAKRAFT AS , Program:Teknologiutvikling",
        vedtaksdato: Date.UTC(2024, 1, 5),
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
        url: "/",
    },
    {
        saksnummer: "25/2638",
        prosjekttittel: "Energireduksjon Avenyen 14",
        prosjekteier: "917358761",
        stottebelop_vedtatt: 1950000,
        levetid_estimert: 25,
        klimaresultat_vedtatt: 0,
        energiresultat_vedtatt: 539628,
        stotteobjekt_navn: "Fartøy",
        stotteobjekt_antall: 4,
        status: "Under gjennomføring",
        stotteprogram: null,
        sektor: "Maritim transport",
        prosjektfylke: "Agder",
        prosjektkommune: "Kristiansand",
        prosjektstart_gjeldende_tid: 1769986800000,
        prosjektslutt_gjeldende_tid: 1793401200000,
        beskrivelse: "Firma:AVENYEN EIENDOM AS , Program:Forbedring av energitilstand i yrkesbygg",
        vedtaksdato: 1740441600000,
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
    },
    {
        saksnummer: "18/13849",
        prosjekttittel: "Energistyring og -oppfølging: Beste tilgjengelige teknologi i bygg",
        prosjekteier: "917358762",
        stottebelop_vedtatt: 9273281,
        levetid_estimert: 5,
        klimaresultat_vedtatt: 512465,
        energiresultat_vedtatt: 1019939,
        stotteobjekt_navn: null,
        stotteobjekt_antall: null,
        status: "Under gjennomføring",
        stotteprogram: "Energieffektivisering",
        sektor: "Bygninger",
        prosjektfylke: "Oslo",
        prosjektkommune: "Oslo",
        prosjektstart_gjeldende_tid: 1577836800000,
        prosjektslutt_gjeldende_tid: 1735603200000,
        beskrivelse: "Firma:BEDRIFTSVEIEN 68 AS , Program:Energieffektivisering",
        vedtaksdato: Date.UTC(2023, 4, 19),
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
        url: "/",
    },
    {
        saksnummer: "12/1094",
        prosjekttittel: "Ansatteboliger: Varmesentral Forenklet",
        prosjekteier: "912345678",
        stottebelop_vedtatt: 9273281,
        levetid_estimert: 5,
        klimaresultat_vedtatt: 512465,
        energiresultat_vedtatt: 35663,
        stotteobjekt_navn: null,
        stotteobjekt_antall: null,
        status: "Ferdigstilt",
        stotteprogram: "Forprosjekt",
        sektor: "Bygninger",
        prosjektfylke: "Viken",
        prosjektkommune: "Fredrikstad",
        prosjektstart_gjeldende_tid: 1577836800000,
        prosjektslutt_gjeldende_tid: 1735603200000,
        beskrivelse: "Firma:LANGEDRAG NATURPARK AS , Program:Forprosjekt",
        vedtaksdato: Date.UTC(2022, 10, 2),
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
    },
    {
        saksnummer: "24/3297",
        prosjekttittel: "1574710-02-310-2",
        prosjekteier: "995644886",
        stottebelop_vedtatt: 9273281,
        levetid_estimert: 5,
        klimaresultat_vedtatt: 512465,
        energiresultat_vedtatt: 1250000,
        stotteobjekt_navn: "Lastebil",
        stotteobjekt_antall: 2,
        status: "Under gjennomføring",
        stotteprogram: "Markedsintroduksjon",
        sektor: "Landtransport",
        prosjektfylke: "Rogaland",
        prosjektkommune: "Stavanger",
        prosjektstart_gjeldende_tid: 1577836800000,
        prosjektslutt_gjeldende_tid: 1735603200000,
        beskrivelse: "Firma:NORDEA FINANCE EQUIPMENT AS , Program:Markedsintroduksjon",
        vedtaksdato: Date.UTC(2024, 0, 15),
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
    },
    {
        saksnummer: "24/3476",
        prosjekttittel: "Data celle",
        prosjekteier: "995644886",
        stottebelop_vedtatt: 9273281,
        levetid_estimert: 5,
        klimaresultat_vedtatt: 512465,
        energiresultat_vedtatt: 1250000,
        stotteobjekt_navn: "Lastebil",
        stotteobjekt_antall: 1,
        status: "Under gjennomføring",
        stotteprogram: "Markedsintroduksjon",
        sektor: "Landtransport",
        prosjektfylke: "Rogaland",
        prosjektkommune: "Haugesund",
        prosjektstart_gjeldende_tid: 1577836800000,
        prosjektslutt_gjeldende_tid: 1735603200000,
        beskrivelse: "Firma:NORDEA FINANCE EQUIPMENT AS , Program:Markedsintroduksjon",
        vedtaksdato: Date.UTC(2024, 2, 8),
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
    },
    {
        saksnummer: "23/58721",
        prosjekttittel: "1730452 Elektrisk gravemaskin Doosan DX165WR-7",
        prosjekteier: "995644886",
        stottebelop_vedtatt: 9273281,
        levetid_estimert: 5,
        klimaresultat_vedtatt: 512465,
        energiresultat_vedtatt: 1250000,
        stotteobjekt_navn: "Anleggsmaskin",
        stotteobjekt_antall: 1,
        status: "Ferdigstilt",
        stotteprogram: "Teknologiutvikling",
        sektor: "Bygg og anlegg",
        prosjektfylke: "Trøndelag",
        prosjektkommune: "Trondheim",
        prosjektstart_gjeldende_tid: 1451606400000,
        prosjektslutt_gjeldende_tid: 1609372800000,
        beskrivelse: "Firma:NORDEA FINANCE EQUIPMENT AS , Program:Teknologiutvikling",
        vedtaksdato: Date.UTC(2023, 8, 12),
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
    },
    {
        saksnummer: "21/9715",
        prosjekttittel: "2 stk. ZE85 og 1 stk. 310 Z-line gravemaskin",
        prosjekteier: "989123456",
        stottebelop_vedtatt: 9273281,
        levetid_estimert: 5,
        klimaresultat_vedtatt: 512465,
        energiresultat_vedtatt: 1250000,
        stotteobjekt_navn: "Anleggsmaskin",
        stotteobjekt_antall: 3,
        status: "Under gjennomføring",
        stotteprogram: "Markedsintroduksjon",
        sektor: "Bygg og anlegg",
        prosjektfylke: "Nordland",
        prosjektkommune: "Bodø",
        prosjektstart_gjeldende_tid: 1577836800000,
        prosjektslutt_gjeldende_tid: 1735603200000,
        beskrivelse: "Firma:EL-MASKINUTLEIE AS , Program:Markedsintroduksjon",
        vedtaksdato: Date.UTC(2021, 6, 1),
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
    },
    {
        saksnummer: "12/314",
        prosjekttittel: "Bulk Sondre Fossen: Lokale energisentraler",
        prosjekteier: "979123456",
        stottebelop_vedtatt: 9273281,
        levetid_estimert: 5,
        klimaresultat_vedtatt: 512465,
        energiresultat_vedtatt: 1250000,
        stotteobjekt_navn: null,
        stotteobjekt_antall: null,
        status: "Ferdigstilt",
        stotteprogram: "Energieffektivisering",
        sektor: "Industri",
        prosjektfylke: "Agder",
        prosjektkommune: "Kristiansand",
        prosjektstart_gjeldende_tid: 1577836800000,
        prosjektslutt_gjeldende_tid: 1735603200000,
        beskrivelse: "Firma:BIO ENERGY AS , Program:Energieffektivisering",
        vedtaksdato: Date.UTC(2019, 11, 20),
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
    },
    {
        saksnummer: "24/2316",
        prosjekttittel: "Reduksjon av energiforbruk, spillvarme- og CO₂-utslipp fra prosessovner A300",
        prosjekteier: "937123456",
        stottebelop_vedtatt: 9273281,
        levetid_estimert: 5,
        klimaresultat_vedtatt: 512465,
        energiresultat_vedtatt: 1250000,
        stotteobjekt_navn: null,
        stotteobjekt_antall: null,
        status: "Under gjennomføring",
        stotteprogram: "Teknologiutvikling",
        sektor: "Energiforsyning og energisystem",
        prosjektfylke: "Vestland",
        prosjektkommune: "Sogndal",
        prosjektstart_gjeldende_tid: 1577836800000,
        prosjektslutt_gjeldende_tid: 1735603200000,
        beskrivelse: "Firma:KVERNELAND GROUP OPERATIONS NORWAY , Program:Teknologiutvikling",
        vedtaksdato: Date.UTC(2024, 5, 10),
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
    },
    {
        saksnummer: "19/2132",
        prosjekttittel: "Forprosjekt for omlegging til lavutslippsdrift",
        prosjekteier: "930123456",
        stottebelop_vedtatt: 9273281,
        levetid_estimert: 5,
        klimaresultat_vedtatt: 512465,
        energiresultat_vedtatt: 1250000,
        stotteobjekt_navn: null,
        stotteobjekt_antall: null,
        status: "Under gjennomføring",
        stotteprogram: "Forprosjekt",
        sektor: "Banebrytende klima- og energiteknologi",
        prosjektfylke: "Innlandet",
        prosjektkommune: "Lillehammer",
        prosjektstart_gjeldende_tid: 1451606400000,
        prosjektslutt_gjeldende_tid: 1609372800000,
        beskrivelse: "Firma:K37 EIENDOM AS , Program:Forprosjekt",
        vedtaksdato: Date.UTC(2020, 3, 3),
        prosjekttype: null,
        annen_prosjekt_kategori: null,
        kundetype: "bedrift",
    },
];
